import request from '@/utils/request';
import { query } from 'mars2d';

// 查询角色列表
export function listRole(query) {
  return request({
    url: process.env.VUE_APP_PROXY_API + '/rolelist',
    method: 'get',
    params: query
  });
}

// 查询角色详情
export function getRole(roleId) {
  return request({
    url: process.env.VUE_APP_PROXY_API + '/role/' + roleId,
    method: 'get'
  });
}

// 新增角色
export function addRole(data) {
  return request({
    url: process.env.VUE_APP_PROXY_API + '/addRole',
    method: 'post',
    data: data
  });
}

// 修改角色
export function updateRole(data) {
  return request({
    url: process.env.VUE_APP_PROXY_API + '/role',
    method: 'put',
    data: data
  });
}

// 角色数据权限
export function dataScope(data) {
  return request({
    url: process.env.VUE_APP_PROXY_API + '/roledatascope',
    method: 'put',
    data: data
  });
}

// 角色状态修改
export function changeRoleStatus(roleId, status) {
  var data = {
    roleId: roleId,
    status: status
  };
  return request({
    url: process.env.VUE_APP_PROXY_API + '/role',
    method: 'put',
    data: data
  });
}

// 删除角色
export function delRole(roleId) {
  return request({
    url: process.env.VUE_APP_PROXY_API + '/delRole/' + roleId,
    method: 'delete'
  });
}
export function getListrole(id) {
  return request({
    url: process.env.VUE_APP_PROXY_API + '/menu/role/' + id,
    method: 'get'
  });
}
export function getRoutes() {
  return request({
    url: process.env.VUE_APP_PROXY_API + '/menurole',
    method: 'get'
  });
}
export function getMenuNames() {
  return request({
    url: process.env.VUE_APP_PROXY_API + '/menuids',
    method: 'get'
  });
}

// 区域权限--（新增或修改）
export function addArea(data) {
  return request({
    url: process.env.VUE_APP_PROXY_API + '/addRoleArea',
    method: 'post',
    data: data
  });
}

// 区域权限详情
export function getAreaInfo(query) {
  return request({
    url: process.env.VUE_APP_PROXY_API + '/roleAreaList',
    method: 'get',
    params: query
  });
}